import { Tag } from 'antd';

export const STATUS_META = {
  OPEN: ['Đang chờ tài xế', 'processing'],
  MATCHED: ['Đã có tài xế nhận', 'success'],
  CANCELLED: ['Đã hủy', 'warning'],
  EXPIRED: ['Hết hạn', 'default'],
};

export const STATUS_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái' },
  ...Object.entries(STATUS_META).map(([value, meta]) => ({ value, label: meta[0] })),
];

export const formatDemandDate = (value) => (value ? new Date(value).toLocaleString('vi-VN') : '—');
export const formatDemandMoney = (value) => (value == null ? '—' : `${Number(value).toLocaleString('vi-VN')} ₫`);

export const getRideDemandErrorMessage = (error) => error?.response?.data?.message
  || error?.response?.data?.reason
  || 'Không thể xử lý yêu cầu hẹn giờ';

export function RideDemandStatusTag({ status }) {
  const [label, color] = STATUS_META[status] || [status || '—', 'default'];
  return <Tag color={color}>{label}</Tag>;
}
